import { ExternalState } from '../external-state';
import { DeviceOutput } from '../output/device';
import { RtcConnection } from '../rtc/connection';
import { BaseInput } from './base';

export class RtcInput extends BaseInput {
  protected initPromise?: Promise<void>;
  protected analyser: AnalyserNode;
  protected streamSource?: MediaStreamAudioSourceNode;
  protected gainNode: GainNode;
  public readonly isMuted = new ExternalState<boolean>(false);
  
  constructor(
    protected name: string,
    protected audioContext: AudioContext,
    public readonly rtcConection: RtcConnection,
  ) {
    super(name, audioContext);
    this.analyser = this.audioContext.createAnalyser();
    this.rtcConection.outputStream.connect(this.analyser);

    this.gainNode = this.audioContext.createGain();
    this.gainNode.gain.value = 1;
    this.rtcConection.outputStream.connect(this.gainNode)
    this.init()
  }

  protected async init() {
    if(!this.initPromise) this.initPromise = (async () => {
      
    })()

    return this.initPromise; 
  }

  toggleMute() {
    if(this.gainNode.gain.value === 1) {
      this.gainNode.gain.value = 0;
      this.isMuted.set(true);
    }
    else {
      this.gainNode.gain.value = 1;
      this.isMuted.set(false);
    }
  }

  async connectCanvas(canvas: HTMLCanvasElement) {
    await this.init();
    const canvasContext = canvas.getContext('2d')!;
    const analyser = this.analyser;
    analyser.fftSize = 32;
    let frequencyData = new Uint8Array(analyser.frequencyBinCount);
    const update = () => {
      requestAnimationFrame(update);
      canvasContext.clearRect(0, 0, canvas.width, canvas.height);

      analyser.getByteFrequencyData(frequencyData);

      let barLength = frequencyData.reduce((acc, cur) => acc + cur, 0) / frequencyData.length;
      canvasContext.fillStyle = 'rgb(' + (barLength-50) + ',126,0)';
      canvasContext.fillRect(0, 0, barLength / 255 * canvas.width, canvas.height);
    }

    update();
  }


  connectOutput(output: DeviceOutput) {
    this.gainNode.connect(output.getDestination());
    output.finishConnection(this);
  }

  disconnectOutput(output: DeviceOutput) {
    try {
      this.gainNode.disconnect(output.getDestination());
    } catch {}
  }
}